<template>
    <div>
        <div class="half-half border-top">
            <div :class="{ 'half-half': $parent.individual_days, 'full-width': $parent.individual_days }">

                <div :class="{'right': !$parent.individual_days }" v-if="!$parent.individual_days">
                    <div class="content-block hidden-xs" v-if="!this.$root.auth || !this.$root.auth.user_id" v-html="$parent.locale.text_participant_description"></div>

                    <router-link v-if="!this.$root.auth || !this.$root.auth.user_id" :to="{ name: 'auth.login', query: { back: $route.fullPath } }" class="cta-button red hidden-xs" v-html="$root.locale.global.button_login"></router-link>

                    <div class="box-layout-inner existing-participants" v-if="participants.length > 0">
                        <transition name="slide-fade">
                            <div id="existingParticipants" class="half-half blue">
                                <div v-for="(participant, key) in participants" v-bind:class="{ disabled: !isAvailable(participant.dob, participant) }">
                                    <existing-participant @addchosen="addParticipant" @removechosen="removeParticipant" v-bind:selection="selection" v-bind:participant="participant" v-bind:available="isAvailable(participant.dob, participant)"></existing-participant>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                <div :class="{'left': !$parent.individual_days }" v-if="!$parent.individual_days">
                    <div class="content-block hidden-sm hidden-md hidden-lg" v-if="!this.$root.auth || !this.$root.auth.user_id" v-html="$parent.locale.text_participant_description"></div>

                    <router-link v-if="!this.$root.auth || !this.$root.auth.user_id" :to="{ name: 'auth.login', query: { back: $route.fullPath } }" class="cta-button red hidden-sm hidden-md hidden-lg" v-html="$root.locale.global.button_login"></router-link>

                    <transition name="slide-fade">
                        <div class="box-layout-inner alert" v-bind:key="0"  v-show="success">
                            <div class="full-width green">
                                <span>Participant has been successfully added.</span>
                            </div>
                        </div>
                    </transition>
                    <new-participant @newparticipant="newParticipant" v-bind:key="1"></new-participant>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" v-else>
                    <div class="content-block" v-if="!this.$root.auth || !this.$root.auth.user_id" v-html="$parent.locale.text_participant_description"></div>

                    <router-link v-if="!this.$root.auth || !this.$root.auth.user_id" :to="{ name: 'auth.login',  query: { back: $route.fullPath } }" class="cta-button red" v-html="$root.locale.global.button_login"></router-link>

                    <div class="box-layout-inner existing-participants" v-if="participants.length > 0">
                        <transition name="slide-fade">
                            <div id="existingParticipants" class="half-half blue">
                                <div v-for="(participant, key) in participants" v-bind:class="{ disabled: !isAvailable(participant.dob) }">
                                    <existing-participant @addchosen="addParticipant" @removechosen="removeParticipant" v-bind:selection="selection" v-bind:participant="participant" v-bind:available="isAvailable(participant.dob, participant)"></existing-participant>
                                </div>
                            </div>
                        </transition>
                    </div>

                    <transition name="slide-fade">
                        <div class="box-layout-inner alert" v-bind:key="0"  v-show="success">
                            <div class="full-width green">
                                <span>Participant has been successfully added.</span>
                            </div>
                        </div>
                    </transition>
                    <new-participant @newparticipant="newParticipant" v-bind:key="1"></new-participant>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    Number.prototype.isOdd = function(num){
        return num % 2;
    }

    export default {
        props: ['booking_id', 'current', 'selection'],
        data() {
            return {
                participants: [],
                required_fields: [],
                success: false,
            }
        },
        methods: {
            newParticipant: function(id, participant) {
                this.success = true;
                this.participants.unshift({
                    id,
                    first_name: participant.first_name,
                    last_name: participant.last_name,
                    dob: participant.dob
                });
                this.addParticipant(id);
                setTimeout(() => { this.success = false}, 2500)
            },
            addParticipant: function (id) {
                this.$emit('addchosen', id);
            },
            removeParticipant: function (id) {
                this.$emit('removechosen', id);
            },
            isAvailable: function (dob, participant = null) {
                var birthday = dob.toDate();
                if(!birthday)
                    return false;

                //Getting the earliest start date if there on days route
                if(this.selection.days_running.length > 0) {
                    var earliest_selected_date = "";
                    var selection = this.selection;
                    Object.keys(selection.days_running).map(function(key) {
                        var dates = selection.days_running[key]
                        //Got the packages, now just need to loop through each date selected in each package.
                        Object.keys(dates).map(function(second_key) {
                            var date = dates[second_key];
                            if(earliest_selected_date > date || earliest_selected_date == "") {
                                earliest_selected_date = date;
                            }
                        })
                    })
                    var start_date = earliest_selected_date.toDate().getTime();
                } else {
                    var latest_available_date = "";
                    var addons = this.$parent.addons;
                    Object.keys(addons).map(function(key) {
                        var dates = addons[key].days_running;
                        //Got the packages, now just need to loop through each date that this package runs on.
                        Object.keys(dates).map(function(second_key) {
                            var date = dates[second_key];
                            if(latest_available_date < date || latest_available_date == "") {
                                latest_available_date = date;
                            }
                        })
                    })
                    var start_date = latest_available_date.toDate().getTime();
                }

                //Checking the dob given would mean the age is above the minimum and below the max for the current package
                var result = birthday.getAge(start_date) >= this.current.min_age && birthday.getAge(start_date) <= this.current.max_age;

                //If the result is false and a participant is provided, remove them from the selection
                if(!result && participant != null && this.selection.participants.includes(participant.id)) {
                    //Let the user know we're removing this child
                    this.$root.alert(this.$parent.locale.text_error_child_removed_from_booking);

                    this.removeParticipant(participant.id);
                }

                //Return this result
                return result;

            }

        },
        computed: {
            priceChange: function() {
                var price = this.time.price;
                return (price >= 0 ? (price == 0 ? false :'+ £'+Math.abs(price)) : '- £'+Math.abs(price));
            }
        },
        created() {
            window.router = this.$route;
            this.$validator.remove('valid_date');// Want to remove it incase it already exists.
            this.$validator.extend('valid_date', {
                getMessage: field => 'Please provide a valid date',
                validate: value => value.isValidDate()
            });
            this.$validator.remove('allowed_age');// Want to remove it incase it already exists.
            this.$validator.extend('allowed_age', {
                getMessage: field => 'The participant will not be at the correct age to attend this activity.',
                validate: value => {
                    return this.isAvailable(value);
                }
            });

            axios.get('/camp-booking/participants')
                .then(response => {
                    //ordering participants by their names ASC
                    this.participants = response.data.data.sort(function(a, b) {
                        return a.first_name + a.last_name > b.first_name + b.last_name;
                    })
                });
        },
        components: {
            'existing-participant': require('./ExistingParticipant.vue'),
            'new-participant': require('./NewParticipant.vue')
        },

    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// WhosAttending.vue?8841c370